import { render, staticRenderFns } from "./ontologyStructureKnowledgeGraph.vue?vue&type=template&id=63728003&scoped=true"
import script from "./ontologyStructureKnowledgeGraph.vue?vue&type=script&lang=js"
export * from "./ontologyStructureKnowledgeGraph.vue?vue&type=script&lang=js"
import style0 from "./ontologyStructureKnowledgeGraph.vue?vue&type=style&index=0&id=63728003&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63728003",
  null
  
)

export default component.exports